import { StyleSheet, } from "react-native";
import * as Device from 'expo-device';
import { useFonts} from 'expo-font';

// import {   
//   Kufam_400Regular,
//   Kufam_600SemiBold,
//   Kufam_700Bold,
//   Kufam_900Black,
//  } from '@expo-google-fonts/kufam';

// import {   
//   IBMPlexSerif_400Regular,
//   IBMPlexSerif_600SemiBold,
//   IBMPlexSerif_700Bold,
//  } from '@expo-google-fonts/ibm-plex-serif';

 import {   
  SourceSerifPro_400Regular,
  SourceSerifPro_600SemiBold,
  SourceSerifPro_700Bold,
  SourceSerifPro_900Black
 } from '@expo-google-fonts/source-serif-pro';

// import {   
//   Besley_400Regular,
//   Besley_600SemiBold,
//   Besley_700Bold,
//   Besley_900Black
//  } from '@expo-google-fonts/besley';

 import {   
  AzeretMono_400Regular,
  AzeretMono_600SemiBold,
  AzeretMono_700Bold,
  AzeretMono_900Black
 } from '@expo-google-fonts/azeret-mono';

// import {   
//         Bitter_400Regular,
//         Bitter_700Bold,
//         Bitter_600SemiBold,
//         Bitter_900Black,
//        } from '@expo-google-fonts/bitter';

// import {         
//         Cabin_400Regular,
//         Cabin_600SemiBold,
//         Cabin_700Bold,
//        } from '@expo-google-fonts/cabin';

// import {
//         Caveat_400Regular,
//         Caveat_600SemiBold,
//         Caveat_700Bold,
//       } from '@expo-google-fonts/caveat';

// import {      
//         EBGaramond_400Regular,
//         EBGaramond_600SemiBold,
//         EBGaramond_700Bold,
//         EBGaramond_800ExtraBold
//       } from '@expo-google-fonts/eb-garamond';

import {      
        JetBrainsMono_400Regular,
        JetBrainsMono_600SemiBold,
        JetBrainsMono_700Bold,
        JetBrainsMono_800ExtraBold
      } from '@expo-google-fonts/jetbrains-mono';

import {      
        Lato_400Regular,
        Lato_700Bold,
        Lato_900Black,
      } from '@expo-google-fonts/lato';

// import {      
//         Lora_400Regular,
//         Lora_600SemiBold,
//         Lora_700Bold,
//       } from '@expo-google-fonts/lora';

// // import {      
// //         MPLUS1Code_400Regular,
// //         MPLUS1Code_600SemiBold,
// //         MPLUS1Code_700Bold,
// //       } from '@expo-google-fonts/m-plus-1-code'; //too big

// // import {      
// //         MPLUSRounded1c_400Regular,
// //         MPLUSRounded1c_700Bold,
// //         MPLUSRounded1c_900Black,
// //       } from '@expo-google-fonts/m-plus-rounded-1c';

import {      
        OpenSans_400Regular,
        OpenSans_600SemiBold,
        OpenSans_700Bold,
        OpenSans_800ExtraBold
      } from '@expo-google-fonts/open-sans';

// import {      
//         Oswald_400Regular,
//         Oswald_600SemiBold,
//         Oswald_700Bold,
//       } from '@expo-google-fonts/oswald';

import {      
        PTSans_400Regular,
        PTSans_700Bold,
      } from '@expo-google-fonts/pt-sans';

// import {      
//         Raleway_400Regular,
//         Raleway_600SemiBold,
//         Raleway_700Bold,
//         Raleway_900Black,
//       } from '@expo-google-fonts/raleway';

// import {      
//         Recursive_400Regular,
//         Recursive_600SemiBold,
//         Recursive_700Bold,
//         Recursive_900Black,
//       } from '@expo-google-fonts/recursive';

import {      
        Roboto_400Regular,
        Roboto_700Bold,
        Roboto_900Black,
      } from '@expo-google-fonts/roboto';

import {      
        Signika_400Regular,
        Signika_600SemiBold,
        Signika_700Bold,
      } from '@expo-google-fonts/signika';

// import {      
//         Spectral_400Regular,
//         Spectral_600SemiBold,
//         Spectral_700Bold,
//         Spectral_800ExtraBold
//       } from '@expo-google-fonts/spectral';

import {      
        YanoneKaffeesatz_400Regular,
        YanoneKaffeesatz_600SemiBold,
        YanoneKaffeesatz_700Bold
      } from '@expo-google-fonts/yanone-kaffeesatz';

// import {      
//         Ubuntu_400Regular,
//         Ubuntu_500Medium,
//         Ubuntu_700Bold
//       } from '@expo-google-fonts/ubuntu';

import {      
        Nunito_400Regular,
        Nunito_600SemiBold,
        Nunito_700Bold,
        Nunito_900Black,
      } from '@expo-google-fonts/nunito';      

// import {      
//         NunitoSans_400Regular,
//         NunitoSans_600SemiBold,
//         NunitoSans_700Bold,
//         NunitoSans_900Black,
//       } from '@expo-google-fonts/nunito-sans';

// // import {      
// //         PatrickHand_400Regular,
// //       } from '@expo-google-fonts/patrick-hand';

import {      
        Chivo_400Regular,
        Chivo_700Bold,
        Chivo_900Black,
      } from '@expo-google-fonts/chivo';      

// import {      
//         Overlock_400Regular,
//         Overlock_700Bold,
//         Overlock_900Black,
//       } from '@expo-google-fonts/overlock';

import {      
        Sansita_400Regular,
        Sansita_700Bold,
        Sansita_900Black,
      } from '@expo-google-fonts/sansita';
      
import {      
    MeriendaOne_400Regular,
      } from '@expo-google-fonts/merienda-one';

import {      
    DavidLibre_400Regular,
    DavidLibre_700Bold
      } from '@expo-google-fonts/david-libre';

import {      
  Graduate_400Regular,
      } from '@expo-google-fonts/graduate';

// import {      
//   MateSC_400Regular,
//       } from '@expo-google-fonts/mate-sc';      

// import {      
//   Copse_400Regular,
//       } from '@expo-google-fonts/copse';      

import {      
  Oxanium_400Regular,
  Oxanium_600SemiBold,
  Oxanium_700Bold,
  Oxanium_800ExtraBold
      } from '@expo-google-fonts/oxanium';

import {      
  SyneMono_400Regular,
      } from '@expo-google-fonts/syne-mono';
      

import {      
  Prociono_400Regular,
      } from '@expo-google-fonts/prociono';      

import {      
  Barriecito_400Regular,
      } from '@expo-google-fonts/barriecito';      
import { Connection, ConnectionHis } from "./Connection";
import { Data } from "./Data";

// import {      
//   Offside_400Regular,
//       } from '@expo-google-fonts/offside';      

// import {      
//   Warnes_400Regular,
//       } from '@expo-google-fonts/warnes';


/*   ====================================================================   */

export class UTheme 
{
  public static readonly Blue  = 0;
  public static readonly Green = 1;
  public static readonly Gray  = 2;
  public static readonly Metal = 3;
  public static readonly Multi = 4;
}

/*   ====================================================================   */

export class FontInfo
{
  public static bLoaded       = false;
  public static iTheme        = UTheme.Multi;
  public static iFont         = 1;
  public static iFontSize     = 12;
  public static bDarkMode     = false;
  public static bTransparency = true;

  /*   ------------------------------------------------------------------   */

  public static sBackground   = 'white';
  public static sBackgroundTp = 'rgba(255, 255, 255, .8)';
  public static sButton       = '#f5f6fa';
  public static sButton2      = '#e7e7e7';
  public static sForeground   = 'black';
  public static sForegroundTp = 'rgba(64, 64, 64, .8)';
  public static sDivider      = '#eee';
  public static sBorder       = 'rgba(204, 204, 204, .8)';
  public static sGreen        = 'green';
  public static sYellow       = '#ffc40c';
  public static sGray         = 'lightgray';
  public static sLightGreen   = '#03c04a';
  public static sLightBlue    = '#025cfe';
  public static sBuyText      = '#1e90ff'; //'dodgerblue'; //'#389dff'; //'#51a9ff';
  public static sSellText     = 'hotpink';
  public static sGrayTp       = 'rgba(192, 192, 192, .8)';
  
  public static sDividerTp    = 'rgba(238, 238, 238, .7)';
  public static sWhiteTp      = 'rgba(255, 255, 255, .8)';
  public static sDimGrayTp    = 'rgba(162, 162, 162, .8)';

  public static sDimGrayTpTp  = 'rgba(162, 162, 162, .6)'; //'rgba(125, 139, 154, .6)';//

  //public static sButtonTp     = 'rgba(255, 255, 255, .9)'

  /*   ------------------------------------------------------------------   */

  public static ChangeTransparency(bValue : boolean)
  {
  if (FontInfo.bTransparency != bValue)
    {
    FontInfo.bTransparency = bValue;

    FontInfo.ChangeMode(FontInfo.bDarkMode);
    }
  }

  /*   ------------------------------------------------------------------   */

  public static ChangeMode(bMode : boolean)
  {
  FontInfo.bDarkMode = bMode;

  if (FontInfo.bDarkMode)
    {
      FontInfo.sBackground   = 'rgba(44,44,44,1)'; //'white';

      if (FontInfo.bTransparency)
        FontInfo.sBackgroundTp = 'rgba(44,44,44,.7)'; //'rgba(255, 255, 255, .9)';
      else
        FontInfo.sBackgroundTp = 'rgba(44,44,44,1)'; //'rgba(255, 255, 255, .9)';

      FontInfo.sButton       = 'rgba(74,74,74,.2)'; //'#f5f6fa';
      FontInfo.sButton2      = 'rgba(104,104,104,.4)'; //'#e7e7e7';
      FontInfo.sForeground   = 'white'; //'black';
      FontInfo.sDivider      = 'rgba(74,74,74,1)'; //#eee';
      FontInfo.sBorder       = 'rgba(74,74,74,1)';
      FontInfo.sGreen        = '#03c04a'; //parakeet
      FontInfo.sYellow       = 'yellow';
      FontInfo.sGray         = 'gray';
      FontInfo.sDimGrayTp    = 'rgba(192, 192, 192, .8)';
      FontInfo.sForegroundTp = 'rgba(244, 244, 244, .8)';
      //FontInfo.sButtonTp     = 'rgba(44,44,44, .7)'; //'rgba(64,64,64,.7)'; //'rgba(255, 255, 255, .9)'

      // if (ConnectionHis.oColors)
      //   {
      //   ConnectionHis.oColors[2][0] = 'red';
      //   ConnectionHis.oColors[2][1] = 'red';
      //   }
    }
  else
    {
      FontInfo.sBackground   = 'white';

      if (FontInfo.bTransparency)
        FontInfo.sBackgroundTp = 'rgba(244, 244, 244,.8)';
      else
        FontInfo.sBackgroundTp = 'rgba(244, 244, 244,1)';

      FontInfo.sButton       = '#f5f6fa';
      FontInfo.sButton2      = '#e7e7e7';
      FontInfo.sForeground   = 'black';
      FontInfo.sDivider      = '#eee';
      FontInfo.sBorder       = 'rgba(204, 204, 204, .8)';
      FontInfo.sGreen        = 'green';
      FontInfo.sYellow       = '#ffc40c';
      FontInfo.sGray         = 'lightgray';
      FontInfo.sDimGrayTp    = 'rgba(162, 162, 162, .8)';
      FontInfo.sForegroundTp = 'rgba(64, 64, 64, .8)';
      //FontInfo.sButtonTp     = 'rgba(255, 255, 255, .9)'

      // if (ConnectionHis.oColors)
      //   {
      //   ConnectionHis.oColors[2][0] = FontInfo.sGrayTp;
      //   ConnectionHis.oColors[2][1] = FontInfo.sGrayTp;
      //   }
    }
  }

  /*   ------------------------------------------------------------------   */

  static LoadFonts() : [boolean, Error | null]
  {
    if (!FontInfo.DEV_NAME)
      {
      return( useFonts({
        Lato_400Regular,
        Lato_700Bold,
        Lato_900Black
      }));        
    
      //return([true, null]);
      }

    return( useFonts({
    // BethEllen_400Regular,
    // Warnes_400Regular,

    // Offside_400Regular,

    Barriecito_400Regular,

    Prociono_400Regular,

    SyneMono_400Regular,

    Oxanium_400Regular,
    Oxanium_600SemiBold,
    Oxanium_700Bold,
    Oxanium_800ExtraBold,
  

    // Copse_400Regular,

    // MateSC_400Regular,

    Graduate_400Regular,

    DavidLibre_400Regular,
    DavidLibre_700Bold,

    MeriendaOne_400Regular,

    // Overlock_400Regular,
    // Overlock_700Bold,
    // Overlock_900Black,

    Sansita_400Regular,
    Sansita_700Bold,
    Sansita_900Black,

    // PatrickHand_400Regular,

    Chivo_400Regular,
    Chivo_700Bold,
    Chivo_900Black,

    // IBMPlexSerif_400Regular,
    // IBMPlexSerif_600SemiBold,
    // IBMPlexSerif_700Bold,
  
    SourceSerifPro_400Regular,
    SourceSerifPro_600SemiBold,
    SourceSerifPro_700Bold,
    SourceSerifPro_900Black,
  
    // Besley_400Regular,
    // Besley_600SemiBold,
    // Besley_700Bold,
    // Besley_900Black,
  
    AzeretMono_400Regular,
    AzeretMono_600SemiBold,
    AzeretMono_700Bold,
    AzeretMono_900Black,
  
    // Kufam_400Regular,
    // Kufam_600SemiBold,
    // Kufam_700Bold,
    // Kufam_900Black,
  
    // Bitter_400Regular,
    // Bitter_600SemiBold,
    // Bitter_700Bold,
    // Bitter_900Black,

    // Cabin_400Regular,
    // Cabin_600SemiBold,
    // Cabin_700Bold,

    // Caveat_400Regular,
    // Caveat_600SemiBold,
    // Caveat_700Bold,

    // EBGaramond_400Regular,
    // EBGaramond_600SemiBold,
    // EBGaramond_700Bold,
    // EBGaramond_800ExtraBold,

    JetBrainsMono_400Regular,
    JetBrainsMono_600SemiBold,
    JetBrainsMono_700Bold,
    JetBrainsMono_800ExtraBold,

    Nunito_400Regular,
    Nunito_600SemiBold,
    Nunito_700Bold,
    Nunito_900Black,

    // NunitoSans_400Regular,
    // NunitoSans_600SemiBold,
    // NunitoSans_700Bold,
    // NunitoSans_900Black,

    Lato_400Regular,
    Lato_700Bold,
    Lato_900Black,
    
    // Lora_400Regular,
    // Lora_600SemiBold,
    // Lora_700Bold,

    // MPLUS1Code_400Regular,
    // MPLUS1Code_600SemiBold,
    // MPLUS1Code_700Bold,

    // MPLUSRounded1c_400Regular,
    // MPLUSRounded1c_700Bold,
    // MPLUSRounded1c_900Black,

    OpenSans_400Regular,
    OpenSans_600SemiBold,
    OpenSans_700Bold,
    OpenSans_800ExtraBold,

    // Oswald_400Regular,
    // Oswald_600SemiBold,
    // Oswald_700Bold,
    
    PTSans_400Regular,
    PTSans_700Bold,

    // Raleway_400Regular,
    // Raleway_600SemiBold,
    // Raleway_700Bold,
    // Raleway_900Black,

    // Recursive_400Regular,
    // Recursive_600SemiBold,
    // Recursive_700Bold,
    // Recursive_900Black,

    Roboto_400Regular,
    Roboto_700Bold,
    Roboto_900Black,

    Signika_400Regular,
    Signika_600SemiBold,
    Signika_700Bold,

    // Spectral_400Regular,
    // Spectral_600SemiBold,
    // Spectral_700Bold,
    // Spectral_800ExtraBold,

    YanoneKaffeesatz_400Regular,
    YanoneKaffeesatz_600SemiBold,
    YanoneKaffeesatz_700Bold

  }));
  }

  static GetUIFonts()
  {
  return(
  [
    {
      normal: undefined,
      bold: undefined,
      black: undefined,
    },

    {
      normal: 'Lato_400Regular',
      semibold: 'Lato_700Bold',
      bold: 'Lato_700Bold',
      black: 'Lato_900Black',
    },

    {
      normal: 'Chivo_400Regular',
      semibold: 'Chivo_400Regular',
      bold: 'Chivo_700Bold',
      black: 'Chivo_900Black',
    },

    {
      normal: 'AzeretMono_400Regular',
      semibold: 'AzeretMono_600SemiBold',
      bold: 'AzeretMono_700Bold',
      black: 'AzeretMono_900Black',
    },

    // {
    //   normal: 'Bitter_400Regular', //rem
    //   semibold: 'Bitter_600SemiBold',
    //   bold: 'Bitter_700Bold',
    //   black: 'Bitter_900Black',
    // },

    // {
    //   normal: 'Cabin_400Regular', //re
    //   semibold: 'Cabin_600SemiBold',
    //   bold: 'Cabin_700Bold',
    //   black: 'Cabin_700Bold',
    // },

    // {
    //   normal: 'IBMPlexSerif_400Regular', //similar
    //   semibold: 'IBMPlexSerif_600SemiBold',
    //   bold: 'IBMPlexSerif_700Bold',
    //   black: 'IBMPlexSerif_700Bold',
    // },

    // {
    //   normal: 'Arial',
    //   bold: 'Arial',
    //   black: 'Arial',
    // },

    // {
    //   normal: 'Overlock_400Regular',
    //   semibold: 'Overlock_400Regular',
    //   bold: 'Overlock_700Bold',
    //   black: 'Overlock_900Black',      
    // },

    {
      normal: 'Sansita_400Regular',
      semibold: 'Sansita_400Regular',
      bold: 'Sansita_700Bold',
      black: 'Sansita_900Black',      
    },    

    {
      normal: 'SourceSerifPro_400Regular', //similar
      semibold: 'SourceSerifPro_600SemiBold',
      bold: 'SourceSerifPro_700Bold',
      black: 'SourceSerifPro_900Black',
    },

    // {
    //   normal: 'Besley_400Regular', //rem
    //   semibold: 'Besley_600SemiBold',
    //   bold: 'Besley_700Bold',
    //   black: 'Besley_900Black',
    // },

    // {
    //   normal: 'Kufam_400Regular', //big
    //   semibold: 'Kufam_600SemiBold',
    //   bold: 'Kufam_700Bold',
    //   black: 'Kufam_900Black',
    // },

    {
      normal: 'Nunito_400Regular',
      semibold: 'Nunito_600SemiBold',
      bold: 'Nunito_700Bold',
      black: 'Nunito_900Black',
    },


    {
      normal: 'Roboto_400Regular', //large
      semibold: 'Roboto_700Bold',
      bold: 'Roboto_700Bold',
      black: 'Roboto_900Black',
    },

    // // {
    // //   normal: 'NunitoSans_400Regular', //too similar to nunito
    // //   semibold: 'NunitoSans_600SemiBold',
    // //   bold: 'NunitoSans_700Bold',
    // //   black: 'NunitoSans_900Black',
    // // },

    // {
    //   normal: 'PatrickHand_400Regular', //rem
    //   semibold: 'PatrickHand_400Regular',
    //   bold: 'PatrickHand_400Regular',
    //   black: 'PatrickHand_400Regular',
    // },

    {
      normal: 'Oxanium_400Regular',
      semibold: 'Oxanium_600SemiBold',
      bold: 'Oxanium_700Bold',
      black: 'Oxanium_800ExtraBold',
    },                    


    // {
    //   normal: 'EBGaramond_400Regular', //big
    //   semibold: 'EBGaramond_600SemiBold',
    //   bold: 'EBGaramond_700Bold',
    //   black: 'EBGaramond_800ExtraBold',
    // },

    {
      normal: 'JetBrainsMono_400Regular',
      semibold: 'JetBrainsMono_600SemiBold',
      bold: 'JetBrainsMono_700Bold',
      black: 'JetBrainsMono_800ExtraBold',
    },

    // {
    //   normal: 'Lora_400Regular',//rem
    //   semibold: 'Lora_600SemiBold',
    //   bold: 'Lora_700Bold',
    //   black: 'Lora_700Bold',
    // },

    // {
    //   normal: 'MPLUS1Code_400Regular',
    //   semibold: 'MPLUS1Code_600SemiBold',
    //   bold: 'MPLUS1Code_700Bold',
    //   black: 'MPLUS1Code_700Bold',
    // },

    // {
    //   normal: 'MPLUSRounded1c_400Regular',
    //   semibold: 'MPLUSRounded1c_700Bold',
    //   bold: 'MPLUSRounded1c_700Bold',
    //   black: 'MPLUSRounded1c_900Black',
    // },

    {
      normal: 'OpenSans_400Regular', //same as roboto, more vertical space
      semibold: 'OpenSans_600SemiBold',
      bold: 'OpenSans_700Bold',
      black: 'OpenSans_800ExtraBold',
    },

    // {
    //   normal: 'Oswald_400Regular',//rem
    //   semibold: 'Oswald_600SemiBold',
    //   bold: 'Oswald_700Bold',
    //   black: 'Oswald_700Bold',
    // },

    {
      normal: 'PTSans_400Regular', //similar big
      semibold: 'PTSans_700Bold',
      bold: 'PTSans_700Bold',
      black: 'PTSans_700Bold',
    },

    {
      normal: 'Signika_400Regular', //similar to roboto, big
      semibold: 'Signika_600SemiBold',
      bold: 'Signika_700Bold',
      black: 'Signika_700Bold',
    },

    // {
    //   normal: 'Caveat_700Bold',
    //   semibold: 'Caveat_600SemiBold',
    //   bold: 'Caveat_700Bold',
    //   black: 'Caveat_700Bold',
    // },

    // {
    //   normal: 'Raleway_400Regular',//rem
    //   semibold: 'Raleway_600SemiBold',
    //   bold: 'Raleway_700Bold',
    //   black: 'Raleway_900Black',
    // },

    // {
    //   normal: 'Recursive_400Regular',
    //   semibold: 'Recursive_600SemiBold',
    //   bold: 'Recursive_700Bold',
    //   black: 'Recursive_900Black',
    // },

    // {
    //   normal: 'Spectral_400Regular',
    //   semibold: 'Spectral_600SemiBold',
    //   bold: 'Spectral_700Bold',
    //   black: 'Spectral_800ExtraBold',
    // },

    {
      normal: 'YanoneKaffeesatz_400Regular',
      semibold: 'YanoneKaffeesatz_600SemiBold',
      bold: 'YanoneKaffeesatz_700Bold',
      black: 'YanoneKaffeesatz_700Bold',
    },

    {
      normal: 'MeriendaOne_400Regular',
      semibold: 'MeriendaOne_400Regular',
      bold: 'MeriendaOne_400Regular',
      black: 'MeriendaOne_400Regular',
    },    

    {
      normal: 'DavidLibre_400Regular',
      semibold: 'DavidLibre_400Regular',
      bold: 'DavidLibre_700Bold',
      black: 'DavidLibre_700Bold',
    },    

    {
      normal: 'Graduate_400Regular',
      semibold: 'Graduate_400Regular',
      bold: 'Graduate_400Regular',
      black: 'Graduate_400Regular',
    },        

    // {
    //   normal: 'MateSC_400Regular',
    //   semibold: 'MateSC_400Regular',
    //   bold: 'MateSC_400Regular',
    //   black: 'MateSC_400Regular',
    // },            

    // {
    //   normal: 'Copse_400Regular',
    //   semibold: 'Copse_400Regular',
    //   bold: 'Copse_400Regular',
    //   black: 'Copse_400Regular',
    // },                

    {
      normal: 'SyneMono_400Regular',
      semibold: 'SyneMono_400Regular',
      bold: 'SyneMono_400Regular',
      black: 'SyneMono_400Regular',
    },                    

    {
      normal: 'Prociono_400Regular',
      semibold: 'Prociono_400Regular',
      bold: 'Prociono_400Regular',
      black: 'Prociono_400Regular',
    },                        

    {
      normal: 'Barriecito_400Regular',
      semibold: 'Barriecito_400Regular',
      bold: 'Barriecito_400Regular',
      black: 'Barriecito_400Regular',
    },                            

    // {
    //   normal: 'Offside_400Regular',
    //   semibold: 'Offside_400Regular',
    //   bold: 'Offside_400Regular',
    //   black: 'Offside_400Regular',
    // },                                

    // {
    //   normal: 'Warnes_400Regular', //simillar to offside but cursive
    //   semibold: 'Warnes_400Regular',
    //   bold: 'Warnes_400Regular',
    //   black: 'Warnes_400Regular',
    // },                                

    // {
    //   normal: 'BethEllen_400Regular',
    //   semibold: 'BethEllen_400Regular',
    //   bold: 'BethEllen_400Regular',
    //   black: 'BethEllen_400Regular',
    // },                                    
  ]);
  }

  static GetWebFonts()
  {
  return(
  [
    {
      normal: undefined,
      bold: undefined,
      black: undefined,
    },

    {
      normal: 'Lato_400Regular',
      semibold: 'Lato_700Bold',
      bold: 'Lato_700Bold',
      black: 'Lato_900Black',
    },

    {
      normal: 'Arial',
      semibold: 'Arial',
      bold: 'Arial',
      black: 'Arial',
    },

    {
      normal: 'serif',
      semibold: 'serif',
      bold: 'serif',
      black: 'serif',
    },    

    {
      normal: 'Verdana',
      semibold: 'Verdana',
      bold: 'Verdana',
      black: 'Verdana',
    },        

    {
      normal: 'Trebuchet MS',
      semibold: 'Trebuchet MS',
      bold: 'Trebuchet MS',
      black: 'Trebuchet MS',
    },        

    {
      normal: 'Lucida Sans',
      semibold: 'Lucida Sans',
      bold: 'Lucida Sans',
      black: 'Lucida Sans',
    },            

    {
      normal: 'Tahoma',
      semibold: 'Tahoma',
      bold: 'Tahoma',
      black: 'Tahoma',
    },                

  ]);
  }

  static GetAndroidFonts()
  {
  return(
  [
    {
      normal: undefined,
      bold: undefined,
      black: undefined,
    },

    {
      normal: 'Lato_400Regular',
      semibold: 'Lato_700Bold',
      bold: 'Lato_700Bold',
      black: 'Lato_900Black',
    },

    {
      normal: 'Arial',
      semibold: 'Arial',
      bold: 'Arial',
      black: 'Arial',
    },

    {
      normal: 'serif',
      semibold: 'serif',
      bold: 'serif',
      black: 'serif',
    },    

    {
      normal: 'Verdana',
      semibold: 'Verdana',
      bold: 'Verdana',
      black: 'Verdana',
    },        

    {
      normal: 'Roboto',
      semibold: 'Roboto',
      bold: 'Roboto',
      black: 'Roboto',
    },        

    {
      normal: 'notosans',
      semibold: 'notosans',
      bold: 'notosans',
      black: 'notosans',
    },            

    {
      normal: 'monospace',
      semibold: 'monospace',
      bold: 'monospace',
      black: 'monospace',
    },                

  ]);
  }

  /*   ------------------------------------------------------------------   */

  public static DEV_NAME  = Device.deviceName;
  public static Fonts     = FontInfo.DEV_NAME? FontInfo.GetUIFonts() : 
                            // Device.osName == "Android"? 
                            // FontInfo.GetAndroidFonts() :
                            FontInfo.GetWebFonts();

  //public static oInfo     = new FontInfo();
  public static appStyles = FontInfo.GetFont();

  /*   ------------------------------------------------------------------   */

  // constructor()
  // {
  // this.GetFont = this.GetFont.bind(this);
  // }

    /*   ------------------------------------------------------------------   */

  public static SetFontParams(iFont     : number, 
                              iFontSize : number,
                              bDarkMode : boolean | undefined)
  {
  if (iFont >= 0 && iFont < FontInfo.Fonts.length)
    {
    FontInfo.iFont     = iFont;
    FontInfo.iFontSize = iFontSize;
    FontInfo.appStyles = FontInfo.GetFont();
    }

  if (bDarkMode != undefined && FontInfo.bDarkMode != bDarkMode)
    this.ChangeMode(bDarkMode);
  }

  /*   ------------------------------------------------------------------   */

  public static SetFont(iIndex : number)
  {
  FontInfo.iFont     = iIndex;
  FontInfo.appStyles = FontInfo.GetFont(); 
  }

  /*   ------------------------------------------------------------------   */

  public static SetFontSize(iSize : number)
  {
  FontInfo.iFontSize = iSize;
  FontInfo.appStyles = FontInfo.GetFont(); 
  }

  /*   ------------------------------------------------------------------   */

  public static GetFont()
  {
  if (FontInfo.iFont <= 0                                || 
      FontInfo.Fonts[FontInfo.iFont]        == undefined ||
      FontInfo.Fonts[FontInfo.iFont].normal == undefined)
  return(
    StyleSheet.create({
      txt_normal: {
        //fontFamily:'Arial',
        paddingHorizontal:2,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_bold: {
        //fontFamily:'Arial',
        paddingHorizontal:2,
        fontWeight:'bold',      
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_black: {
        //fontFamily:'Arial',
        paddingRight:2,
        fontWeight:'bold',
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_semibold: {
        //fontFamily:'Arial',
        paddingHorizontal:2,
        fontWeight:'600',
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

  }));
  else if (FontInfo.Fonts[FontInfo.iFont].normal == 'Arial' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'serif' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'verdana' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'Trebuchet MS' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'Lucida Sans' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'Tahoma' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'Roboto' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'notoserif' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'monospace'
           )
  return(
    StyleSheet.create({
      txt_normal: {
        fontFamily:FontInfo.Fonts[FontInfo.iFont].normal,
        paddingHorizontal:2,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_bold: {
        fontFamily:FontInfo.Fonts[FontInfo.iFont].normal,
        paddingHorizontal:2,
        fontWeight:'bold',      
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_black: {
        fontFamily:FontInfo.Fonts[FontInfo.iFont].normal,
        paddingRight:2,
        fontWeight:'900',
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_semibold: {
        fontFamily:FontInfo.Fonts[FontInfo.iFont].normal,
        paddingHorizontal:2,
        fontWeight:'600',
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

    }));  
  // else if (FontInfo.Fonts[FontInfo.iFont].normal == 'serif')
  //   return(
  //     StyleSheet.create({
  //       txt_normal: {
  //         fontFamily:'serif',
  //         paddingHorizontal:2,
  //         fontSize:FontInfo.iFontSize,
  //         fontVariant: ["tabular-nums"],
  //       },
  
  //       txt_bold: {
  //         fontFamily:'serif',
  //         paddingHorizontal:2,
  //         fontWeight:'bold',      
  //         fontSize:FontInfo.iFontSize,
  //         fontVariant: ["tabular-nums"],
  //       },
  
  //       txt_black: {
  //         fontFamily:'serif',
  //         paddingRight:2,
  //         fontWeight:'900',
  //         fontSize:FontInfo.iFontSize,
  //         fontVariant: ["tabular-nums"],
  //       },
  
  //       txt_semibold: {
  //         fontFamily:'serif',
  //         paddingHorizontal:2,
  //         fontWeight:'600',
  //         fontSize:FontInfo.iFontSize,
  //         fontVariant: ["tabular-nums"],
  //       },
  
  //     }));      
  else if (FontInfo.Fonts[FontInfo.iFont].normal == 'Oxanium_400Regular' || 
          //  FontInfo.Fonts[FontInfo.iFont].normal == 'Roboto_400Regular' ||
           FontInfo.Fonts[FontInfo.iFont].normal == 'Kufam_400Regular')
  return(
    StyleSheet.create({
      txt_normal: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].normal,
        paddingHorizontal:2,
        marginVertical:1,
        paddingTop:1,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_bold: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].bold,
        paddingHorizontal:2,
        marginVertical:1,
        paddingTop:1,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },
    
      txt_black: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].black,
        paddingHorizontal:2,
        marginVertical:1,
        paddingTop:3,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_semibold: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].semibold,
        paddingHorizontal:2,
        marginVertical:1,
        paddingTop:1,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },
   }));
  // else if (FontInfo.Fonts[FontInfo.iFont].normal == 'Roboto_400Regular')
  // return(
  //   StyleSheet.create({
  //     txt_normal: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].normal,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       // paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },

  //     txt_bold: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].bold,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       // paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },
    
  //     txt_black: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].black,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },

  //     txt_semibold: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].semibold,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       // paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },
  //  }));   
  // else if (FontInfo.Fonts[FontInfo.iFont].normal == 'Roboto_400Regular')
  // return(
  //   StyleSheet.create({
  //     txt_normal: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].normal,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       // paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },

  //     txt_bold: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].bold,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       // paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },
    
  //     txt_black: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].black,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },

  //     txt_semibold: {
  //       fontFamily: FontInfo.Fonts[FontInfo.iFont].semibold,
  //       paddingHorizontal:2,
  //       marginVertical:1,
  //       // paddingTop:2,
  //       fontSize:FontInfo.iFontSize,
  //       fontVariant: ["tabular-nums"],
  //     },
  //  }));     
  else return(
    StyleSheet.create({
      txt_normal: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].normal,
        paddingHorizontal:2,
        marginVertical:1,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_bold: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].bold,
        paddingHorizontal:2,
        marginVertical:1,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },
    
      txt_black: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].black,
        paddingHorizontal:2,
        marginVertical:1,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },

      txt_semibold: {
        fontFamily: FontInfo.Fonts[FontInfo.iFont].semibold,
        paddingHorizontal:2,
        marginVertical:1,
        fontSize:FontInfo.iFontSize,
        fontVariant: ["tabular-nums"],
      },
   })
  );
  }

  /*   ------------------------------------------------------------------   */

  }

/*   ====================================================================   */

export class LoginParams
{
public sUsr    : string;
public sPwd    : string;
public sSys    : string;
public sUrl    : string;

constructor(sUsr, sPwd, sSys, sUrl)
{
this.sUsr = sUsr;
this.sPwd = sPwd;
this.sSys = sSys;
this.sUrl = sUrl;
}
}

/*   ====================================================================   */

export class ReturnTypes
{
  public static readonly OK            = 0;
  public static readonly ERR_EMPTY     = 1; 
  public static readonly ERR_DUPLICATE = 2;
  public static readonly ERR_INVALID   = 3;
  public static readonly WAITING       = 4;
}

/*   ====================================================================   */

export class IndicatorType
{
  public static readonly BB      = 0; //ovr
  public static readonly SMA     = 1; //ovr
  public static readonly EMA     = 2; //ovr
  public static readonly TRIMA   = 3; //ovr
  public static readonly DC      = 4; //ovr
  public static readonly KC      = 5; //ovr
  public static readonly ATR     = 6;
  public static readonly RSI     = 7;

  public static readonly DEMA    = 8;  //ovr
  public static readonly TEMA    = 9;  //ovr
  public static readonly TRIX    = 10;
  public static readonly CMI     = 11; 
  public static readonly MACD    = 12; //ovr
  public static readonly RMA     = 13; //ovr
  public static readonly TP      = 14; //ovr
  public static readonly AO      = 15; 
  public static readonly CO      = 16; 
  public static readonly PPO     = 17; 
  public static readonly SO      = 18; 
  public static readonly WR      = 19; 
  public static readonly AB      = 20; //ovr

  public static readonly PO      = 21;
  public static readonly AD      = 22;
  public static readonly CMF     = 23;
  public static readonly EMV     = 24;
  public static readonly FI      = 25;
  public static readonly MFI     = 26;
  public static readonly OBV     = 27;
  public static readonly VPT     = 28;
  public static readonly VOL     = 29;
}

/*   -------------------------------------------------------------------   */

export class LookbackType
{
  public static readonly Min1    = 0;
  public static readonly Hour1   = 1;
  public static readonly Day1    = 2;
  public static readonly Day5    = 3;
  public static readonly Week2   = 4;
  public static readonly Month1  = 5;
  public static readonly Month3  = 6;
  public static readonly Month6  = 7;
  public static readonly Year1   = 8;
  public static readonly Year5   = 9;
  public static readonly YTD     = 10;
  
  public static readonly Min5    = 11;
  //public static readonly Week1   = 12;

}

/*   -------------------------------------------------------------------   */

// export class Lookback 
// {
  
//   public static oLookBacks = {Type: LookbackType.Min1, 
//                                    Text: "1M",
//                                    LookbackMin:1, 
//                                    Period:1, PeriodSub: 1, Max:61, 
//                                    BarType: BarType.SECOND_BAR, DateOnly: false};

//   public static readonly Hour1  = {Type: LookbackType.Hour1, 
//                                    Text: "1H",
//                                    LookbackMin:60, LookbackExtraLB:0, 
//                                    Period:1, PeriodSub: 60, Max:61, 
//                                    BarType: BarType.MINUTE_BAR, DateOnly: false};

//   public static readonly Day1   = {Type: LookbackType.Day1, 
//                                    Text: "1D",
//                                    LookbackMin:1440, 
//                                    Period:30, PeriodSub: 60 * 30, Max:49, 
//                                    BarType: BarType.MINUTE_BAR, DateOnly: false};

//   public static readonly Day5   = {Type: LookbackType.Day5, 
//                                    Text: "5D",    
//                                    LookbackMin:1440 * 5, 
//                                    Period:60, PeriodSub: 60 * 60, Max:121, 
//                                    BarType: BarType.MINUTE_BAR, DateOnly: false};                                   

//   public static readonly Month1 = {Type: LookbackType.Month1, 
//                                    Text: "1M",
//                                    LookbackMin:1440 * 30, 
//                                    Period:1, PeriodSub: 0, Max:1, 
//                                    BarType: BarType.DAILY_BAR, DateOnly: true};

//   public static readonly Month3 = {Type: LookbackType.Month3, 
//                                    Text: "3M",
//                                    LookbackMin:1440 * 90, 
//                                    Period:1, PeriodSub: 0, Max:1, 
//                                    BarType: BarType.DAILY_BAR, DateOnly: true};                                   

//   public static readonly Year1  = {Type: LookbackType.Year1, 
//                                    Text: "1Y",
//                                    LookbackMin:1440 * 365, 
//                                    Period:1, PeriodSub: 0, Max:1, 
//                                    BarType: BarType.WEEKLY_BAR, DateOnly: true};


                                     
//   // public static readonly Week  = {Type: LookbackType.Week, LookbackMin:10080, LookbackExtraLB:0, Period:1*60, PeriodSub: 0, Max:7*24, BarType: BarType.MINUTE_BAR, DateOnly: false};
  
  

//   // public static readonly Year  = {Type: LookbackType.Year, LookbackMin:525600, LookbackExtraLB:0, Period:7*24*60, PeriodSub: 0, Max:1, BarType: BarType.MINUTE_BAR};
//   // public static readonly Month = {Type: LookbackType.Month, LookbackMin:129600, LookbackExtraLB:0, Period:24*60, PeriodSub: 0, Max:1, BarType: BarType.MINUTE_BAR};
//   // public static readonly Year   = {Type: LookbackType.Year, LookbackMin:525600, LookbackExtraLB:0, Period:1, PeriodSub: 0, Max:1, BarType: BarType.WEEKLY_BAR, DateOnly: true};
//   // public static readonly Month3 = {Type: LookbackType.Month, LookbackMin:129600, LookbackExtraLB:0, Period:1, PeriodSub: 0, Max:1, BarType: BarType.DAILY_BAR, DateOnly: true};

//   // public static readonly Week  = {Type: LookbackType.Week, LookbackMin:10080, LookbackExtraLB:0, Period:1*60, PeriodSub: 0, Max:7*24, BarType: BarType.MINUTE_BAR, DateOnly: false};
//   // public static readonly Month  = {Type: LookbackType.Week, LookbackMin:43200, LookbackExtraLB:0, Period:1, PeriodSub: 0, Max:1, BarType: BarType.DAILY_BAR, DateOnly: true};
//   // public static readonly Day    = {Type: LookbackType.Day, LookbackMin:1440, LookbackExtraLB:0, Period:30, PeriodSub: 1800, Max:49, BarType: BarType.MINUTE_BAR, DateOnly: false};
//   // public static readonly Hour   = {Type: LookbackType.Hour, LookbackMin:60, LookbackExtraLB:0, Period:1, PeriodSub: 60, Max:61, BarType: BarType.MINUTE_BAR, DateOnly: false};
//   // public static readonly Min    = {Type: LookbackType.Min, LookbackMin:1, LookbackExtraLB:0, Period:1, PeriodSub: 1, Max:61, BarType: BarType.SECOND_BAR, DateOnly: false};
// }

/*   -------------------------------------------------------------------   */

export class MnmIds
{
public static readonly MNM_REQUEST                                = 100000;

public static readonly MNM_USER                                   = 131003;
public static readonly MNM_PASSWORD                               = 130004;
public static readonly MNM_APP_NAME                               = 130002;
public static readonly MNM_APP_VERSION                            = 131803;
public static readonly MNM_RITHMIC_INFRASTRUCTURE_PLANT           = 153621;
public static readonly MNM_MESSAGE_ID                             = 154211;
          
public static readonly MNM_RITHMIC_SYSTEM_NAME                    = 153628;
public static readonly MNM_TEMPLATE_VERSION                       = 153634
public static readonly MNM_TEMPLATE_ID                            = 154467;

public static readonly MNM_GATEWAY_NAME                           = 153640;
public static readonly MNM_GATEWAY_URI                            = 153641;
public static readonly MNM_GATEWAY_HAS_AGG_QUOTES                 = 153642;

public static readonly MNM_SYMBOL                                 = 110100;
public static readonly MNM_EXCHANGE                               = 110101;
public static readonly MNM_TRADING_SYMBOL                         = 157095;
public static readonly MNM_TRADING_EXCHANGE                       = 157096;
public static readonly MNM_UNDERLYING_SYMBOL                      = 101026;
public static readonly MNM_UNDERLYING_EXCHANGE                    = 154080;
public static readonly MNM_EXPIRATION_DATE                        = 100067;
public static readonly MNM_EXPIRATION_TIME                        = 154373;

public static readonly MNM_MARKET_DEPTH_SIDE                      = 153612;
public static readonly MNM_MARKET_DEPTH_PRICE                     = 154405;
public static readonly MNM_MARKET_DEPTH_SIZE                      = 154406;

public static readonly MNM_PREVIOUS_MARKET_DEPTH_PRICE            = 154906;
public static readonly MNM_PREVIOUS_MARKET_DEPTH_PRICE_FLAG       = 154930;

public static readonly MNM_UPDATE_TYPE                            = 110121;
public static readonly MNM_MARKET_DEPTH_ORDER_PRIORITY            = 153613;
public static readonly MNM_EXCH_ORD_ID                            = 149238;	

public static readonly MNM_FCM_ID                                 = 154013;
public static readonly MNM_IB_ID                                  = 154014;
public static readonly MNM_ACCOUNT_ID                             = 154008;
public static readonly MNM_USER_TYPE                              = 154036;
public static readonly MNM_UNIQUE_USER_ID                         = 153428;

public static readonly MNM_ACCOUNT_BALANCE                        = 156970;
public static readonly MNM_ACCOUNT_CURRENCY                       = 154383;

public static readonly MNM_USER_MSG                               = 132760;
public static readonly MNM_USER_TAG                               = 154119;
public static readonly MNM_DATA_BAR_TYPE                          = 119200;
public static readonly MNM_TIME_BAR_PERIOD                        = 119112;
public static readonly MNM_START_INDEX                            = 153002;
public static readonly MNM_FINISH_INDEX                           = 153003;
public static readonly MNM_DIRECTION                              = 149253;
public static readonly MNM_TIME_ORDER                             = 149307;
public static readonly MNM_USER_MAX_COUNT                         = 154020;

public static readonly MNM_QUAN_TO_FILL                           = 112004;
public static readonly MNM_PRICE_TO_FILL                          = 110306;

public static readonly MNM_RESPONSE_CODE                          = 132766;

public static readonly MNM_NET_CHANGE                             = 100011;
public static readonly MNM_PERCENT_CHANGE                         = 100056;
public static readonly MNM_TRADE_PRICE                            = 100006;
public static readonly MNM_TRADE_VOLUME                           = 100032;

public static readonly MNM_CLOSE_TRADE_PRICE                      = 100021;
public static readonly MNM_OPEN_PRICE                             = 100019;

public static readonly MNM_SETTLEMENT_PRICE                       = 100070;
public static readonly MNM_PREVIOUS_DAYS_ADJUSTED_CLOSING_PRICE   = 154124;

public static readonly MNM_HIGH_PRICE                             = 100012;
public static readonly MNM_LOW_PRICE                              = 100013;

public static readonly MNM_TIMEBAR_MARKER                         = 119100;
public static readonly MNM_TIME_BAR_TRADE_VOLUME                  = 119110;

public static readonly MNM_MARKET_MODE                            = 154106;
public static readonly MNM_BID_PRICE                              = 100022;
public static readonly MNM_ASK_PRICE                              = 100025;
public static readonly MNM_BID_SIZE                               = 100030;
public static readonly MNM_ASK_SIZE                               = 100031;
public static readonly MNM_TRADE_SIZE                             = 100178;

public static readonly MNM_CLEAR_BITS                             = 154571;

public static readonly MNM_SYMBOL_NAME                            = 100003;
public static readonly MNM_PRODUCT_CODE                           = 100749;
public static readonly MNM_INSTRUMENT_TYPE                        = 110116;
public static readonly MNM_MIN_QPRICE_CHANGE                      = 154386;
public static readonly MNM_SECONDS_SINCE_BOE                      = 150100;
public static readonly MNM_PRICE_DISPLAY_FORMAT                   = 154390;

public static readonly MNM_DEVICE_NAME                            = 158100;
public static readonly MNM_USER_SETTINGS                          = 154346;
public static readonly MNM_APP_DEFAULT_SETTINGS                   = 153648;

public static readonly MNM_VERSION                                = 131804;

public static readonly MNM_MTM_SECURITY                           = 154263;
public static readonly MNM_MTM_ACCOUNT                            = 154262;
public static readonly MNM_OPEN_POSITION_PNL                      = 156961;
public static readonly MNM_OPEN_POSITION_QUANTITY                 = 156962;
public static readonly MNM_CLOSED_POSITION_PNL                    = 156963;
public static readonly MNM_AVG_OPEN_FILL_PRICE                    = 154434;
//public static readonly MNM_TOTAL_PNL                              = 150127;
// public static readonly MNM_MTM_SECURITY                           = 154263;
// public static readonly MNM_ORDER_BUY_QTY                          = 154037;
//public static readonly MNM_ORDER_SELL_QTY                         = 154038;



public static readonly MNM_CLOSED_POSITION_QUANTITY               = 156964;
public static readonly MNM_NET_QUANTITY                           = 156967;
public static readonly MNM_AUTO_LIQ_THRESHOLD_CURRENT_VALUE       = 131040;


public static readonly MNM_ORDER_BUY_QTY                          = 154037;
public static readonly MNM_ORDER_SELL_QTY                         = 154038;

public static readonly MNM_BUY_QTY                                = 154260;
public static readonly MNM_SELL_QTY                               = 154261;

public static readonly MNM_FILL_BUY_QTY                           = 154041;
public static readonly MNM_FILL_SELL_QTY                          = 154042;

public static readonly MNM_MARKET_DEPTH_BID_PRICE                 = 154282;
public static readonly MNM_MARKET_DEPTH_BID_SIZE                  = 154283;
public static readonly MNM_MARKET_DEPTH_ASK_PRICE                 = 154284;
public static readonly MNM_MARKET_DEPTH_ASK_SIZE                  = 154285;
public static readonly MNM_MARKET_DEPTH_UPDATE_TYPE               = 157608;

public static readonly MNM_NOTIFY_TYPE                            = 153625;
public static readonly MNM_IS_SNAPSHOT                            = 110121;

public static readonly MNM_STATUS                                 = 110303;
public static readonly MNM_BASKET_ID                              = 110300;
public static readonly MNM_ORIGINAL_BASKET_ID                     = 154497;
public static readonly MNM_LINKED_BASKET_IDS                      = 110358;
public static readonly MNM_BRACKET_TYPE                           = 157087;

public static readonly MNM_USER_ID                                = 131003;

public static readonly MNM_TRADE_EXCHANGE                         = 112021;
public static readonly MNM_TRADE_ROUTE                            = 112016;
public static readonly MNM_EXCHANGE_ORDER_ID                      = 149238;
public static readonly MNM_COMPLETION_REASON                      = 149273;
public static readonly MNM_REPORT_TYPE                            = 120001;

public static readonly MNM_QUANTITY                               = 112004;
public static readonly MNM_PRICE                                  = 110306;
public static readonly MNM_TRIGGER_PRICE                          = 149247;

public static readonly MNM_TRANSACTION_TYPE                       = 112003;
public static readonly MNM_DURATION                               = 112005;
public static readonly MNM_PRICE_TYPE                             = 112008;
public static readonly MNM_ORIG_PRICE_TYPE                        = 154770;
public static readonly MNM_MANUAL_OR_AUTO                         = 154710;

public static readonly MNM_AVG_FILL_PRICE                         = 110322;
public static readonly MNM_TOTAL_FILL_SIZE                        = 154111;
public static readonly MNM_TOTAL_UNFILLED_SIZE                    = 154112;

public static readonly MNM_SEQUENCE_NUMBER                        = 112002;
public static readonly MNM_ORIG_SEQUENCE_NUMBER                   = 149263;
public static readonly MNM_COR_SEQUENCE_NUMBER                    = 149264;

public static readonly MNM_CURRENCY                               = 154382;
public static readonly MNM_COUNTRY_CODE                           = 154172;

public static readonly MNM_TEXT                                   = 120008;
public static readonly MNM_REPORT_TEXT                            = 120028;
public static readonly MNM_REMARKS                                = 154806;

public static readonly MNM_CANCEL_AT_SSBOE                        = 157085;
public static readonly MNM_CANCEL_AT_USECS                        = 157086;
public static readonly MNM_CANCEL_AFTER_SECS                      = 154488;
public static readonly MNM_ORDER_RELEASE_SSBOE                    = 154487;

public static readonly MNM_SHOULD_DEFER_REQUEST                   = 157750;

public static readonly MNM_SUBSCRIBE_FLAG                         = 154352;
public static readonly MNM_DEFAULT_ROUTE                          = 154689;

public static readonly MNM_STRIKE_PRICE                           = 100066;
public static readonly MNM_PUT_CALL_INDICATOR                     = 100109;
public static readonly MNM_IS_UNDERLYING_FOR_BINARY_CONTRACTS     = 154952;

public static readonly MNM_TARGET_QUANTITY                        = 154457;
public static readonly MNM_TARGET_TICKS                           = 154456;

public static readonly MNM_STOP_QUANTITY                          = 154459;
public static readonly MNM_STOP_TICKS	                            = 154458;

public static readonly MNM_TARGET_QUANTITY_RELEASED               = 154460;
public static readonly MNM_STOP_QUANTITY_RELEASED                 = 154466;

public static readonly MNM_LEVEL                                  = 154244;

public static readonly MNM_BRACKET_TRAILING_FIELD_ID              = 157062;

public static readonly MNM_AGGREGATED_QUOTES                      = 153644;

public static readonly MNM_WINDOW_NAME                            = 154629;

};

/*   ====================================================================   */

export class AppMain
{
public static readonly IMAGINARY = -1;

public static bEventTradeAdv     = true;
public static iDef_Sett_Page     = 0;

public static sDef_Symbol?       : string;

public static bReviewChecked?    : boolean;
public static iLastReviewDate?   : number;
public static sLastReviewVer?    : string;
public static iRuns?             : number;

/*   ---------------------------------------------------------------------   */

};

/*   ====================================================================   */

export class EvtItem
{
public iCallBuys                  = 0;
public iPutBuys                   = 0;
//public iOrders                    = 0;

public oOrders    : EventOrder[] = Array(0);

public sCallToken? : string;
public sPutToken?  : string;
public dStrike     : number;

public oCallData?  : Data;
public oPutData?   : Data;

public total_visible      = true;
public working_visible    = true;

constructor(dStrike : number)
{
this.dStrike = dStrike;
}
}

/*   ====================================================================   */

export class EventOrder
{
public dStrike : number;
public bUp     : boolean;

constructor(dStrike : number,
            bUp    : boolean)
            {
            this.dStrike = dStrike;
            this.bUp     = bUp;
            }
}

/*   ====================================================================   */

export class EvtData
{
public oEvtList?  : Map<number, EvtItem> = new Map();
//public oOrders    : EventOrder[] = Array(0);
public sToken     : string;
public sUSymbol   : string;
public sUExchange : string;
public sExpiry    : string;
public sExpiryDt  : string;
public iDiff      : number;
public bLdRefData : boolean;

constructor(sToken     : string,
            sUSymbol   : string,
            sUExchange : string,
            sExpiry    : string,
            sExpiryDt  : string,
            iDiff      : number)
{
this.sToken     = sToken;
this.sUSymbol   = sUSymbol;
this.sUExchange = sUExchange;
this.sExpiry    = sExpiry;
this.sExpiryDt  = sExpiryDt;
this.iDiff      = iDiff;
this.bLdRefData = false;
}
}

/*   ====================================================================   */

export class BookItem
{
public key        : number;

public Price      : number = 0; 
public PriceKey   : string = "";

public AskSize    : number = 0;
public BidSize    : number = 0;
public iY         : number = 0;

/*   ---------------------------------------------------------------------   */

// public C_Price    : number = 0; 
// public C_PriceKey : string = "";

// public C_AskSize  : number = 0;
// public C_BidSize  : number = 0;

// public c_bids?    : string[]   = undefined;
// public c_asks?    : string[]   = undefined;

/*   ---------------------------------------------------------------------   */

//public orders:string[]   = new Array(0);

/*   ---------------------------------------------------------------------   */

constructor(key : number)
{
this.key = key;
}
}

/*   ====================================================================   */

export interface IIndicatorInfo
{
iId        : number;
sId        : string; 

//oPeriods   : IPeriodInfo[];
iPeriod1   : number;
iPeriod2   : number;
iPeriod3   : number;

sDesc?     : string;

iCol1      : number;
iCol2      : number;
iCol3      : number;

bOverlay?  : boolean;

}

/*   ====================================================================   */

export interface IPeriodInfo
{
iPeriod1   : number;
iPeriod2   : number;
iPeriod3   : number;
}

/*   ====================================================================   */

export class IndicatorInfo
{
public sId          : string;
public iId          : number;

// public oPeriods     : IPeriodInfo[];

public iPeriod1     : number;
public iPeriod2     : number; 
public iPeriod3     : number;

public sDesc?       : string;

public iCol1        : number; 
public iCol2        : number; 
public iCol3        : number;

public bOverlay?    : boolean;

constructor({sId, iId, iPeriod1, iPeriod2, iPeriod3, iCol1, iCol2, iCol3, sDesc, bOverlay} : IIndicatorInfo)
{
this.sId      = sId;
this.iId      = iId;
this.sDesc    = sDesc;

this.iCol1    = iCol1;
this.iCol2    = iCol2;
this.iCol3    = iCol3;

this.iPeriod1 = iPeriod1;
this.iPeriod2 = iPeriod2;
this.iPeriod3 = iPeriod3;

this.bOverlay = bOverlay;

// this.oPeriods = oPeriods;

return(this);  
}
}

/*   ====================================================================   */

export class Lookback
{
public LookbackType : number; 
public Text         : string;
public LookbackMin  : number; 
public Period       : number;
public PeriodSub    : number; 
public Max          : number;
public BarType      : number;  
public DateOnly     : boolean;
public Fmt          : string;

constructor({LookbackType, Text, LookbackMin, Period, PeriodSub, Max, BarType, DateOnly, Fmt} : ILookback)
{
this.LookbackType = LookbackType;
this.Text         = Text;
this.LookbackMin  = LookbackMin;
this.Period       = Period;
this.PeriodSub    = PeriodSub;
this.Max          = Max;
this.BarType      = BarType;
this.DateOnly     = DateOnly;
this.Fmt          = Fmt;

return(this);  
}
}

/*   ====================================================================   */

export interface ILookback
{
LookbackType  : number; 
Text          : string;
LookbackMin   : number; 
Period        : number;
PeriodSub     : number; 
Max           : number;
BarType       : number; 
DateOnly      : boolean;
Fmt           : string;
}

/*   ====================================================================   */

export class TemplateId
{
//Market Data    
public static readonly LOGIN_REQUEST						                  = 10;
public static readonly LOGIN_RESPONSE						                  = 11;
public static readonly REFERENCE_DATA_REQUEST			                = 14;
public static readonly REFERENCE_DATA_RESPONSE			              = 15;
public static readonly RITHMIC_SYSTEM_INFO_REQUEST                = 16;
public static readonly RITHMIC_SYSTEM_INFO_RESPONSE               = 17;
public static readonly HEARTBEAT_REQUEST                          = 18;
public static readonly HEARTBEAT_RESPONSE                         = 19;
public static readonly GATEWAY_INFO_REQUEST                       = 20;
public static readonly GATEWAY_INFO_RESPONSE                      = 21;

public static readonly REJECT_RESPONSE						                = 75;
public static readonly USER_ACCOUNT_UPDATE						            = 76;
public static readonly FORCED_LOGOUT						                  = 77;

public static readonly MARKET_DATA_UPDATE_REQUEST				          = 100;
public static readonly MARKET_DATA_UPDATE_RESPONSE				        = 101;
public static readonly GET_INSTRUMENT_BY_UNDERLYING_REQUEST		    = 102;
public static readonly GET_INSTRUMENT_BY_UNDERLYING_RESPONSE	    = 103;
public static readonly GET_INSTRUMENT_BY_UNDERLYING_KEYS_RESPONSE = 104;
public static readonly MARKET_DATA_UPDATE_BY_UNDERLYING_REQUEST	  = 105;
public static readonly MARKET_DATA_UPDATE_BY_UNDERLYING_RESPONSE  = 106;
public static readonly GIVE_TICK_SIZE_TYPE_TABLE_REQUEST		      = 107;
public static readonly GIVE_TICK_SIZE_TYPE_TABLE_RESPONSE		      = 108;
public static readonly SEARCH_SYMBOLS_REQUEST		                  = 109;
public static readonly SEARCH_SYMBOLS_RESPONSE		                = 110;
public static readonly PRODUCT_CODES_REQUEST		                  = 111;
public static readonly PRODUCT_CODES_RESPONSE		                  = 112;
public static readonly FRONT_MONTH_CONTRACT_REQUEST		            = 113;
public static readonly FRONT_MONTH_CONTRACT_RESPONSE		          = 114;
public static readonly DEPTH_BY_ORDER_SNAPSHOT_REQUEST            = 115;
public static readonly DEPTH_BY_ORDER_SNAPSHOT_RESPONSE           = 116;
public static readonly DEPTH_BY_ORDER_UPDATES_REQUEST             = 117;
public static readonly DEPTH_BY_ORDER_UPDATES_RESPONSE            = 118;
public static readonly GET_VOLUME_AT_PRICE_REQUEST                = 119;
public static readonly GET_VOLUME_AT_PRICE_RESPONSE               = 120;
public static readonly AUXILLIARY_REFERENCE_DATA_REQUEST          = 121;
public static readonly AUXILLIARY_REFERENCE_DATA_RESPONSE         = 122;


public static readonly LAST_TRADE								                  = 150;
public static readonly BEST_BID_OFFER							                = 151;
public static readonly TRADE_STATISTICS						                = 152;
public static readonly QUOTE_STATISTICS						                = 153;
public static readonly INDICATOR_PRICES						                = 154;
public static readonly END_OF_DAY_PRICES						              = 155;
public static readonly ORDER_BOOK								                  = 156;
public static readonly MARKET_MODE							                  = 157;
public static readonly OPEN_INTEREST							                = 158;
public static readonly FRONT_MONTH_CONTRACT_UPDATE			          = 159;
public static readonly DEPTH_BY_ORDER						                  = 160;
public static readonly DEPTH_BY_ORDER_END_EVENT				            = 161;
public static readonly SYMBOL_MARGIN_RATE					                = 162;
public static readonly ORDER_PRICE_LIMITS					                = 163;

//Order
public static readonly LOGIN_INFO_REQUEST						              = 300;
public static readonly LOGIN_INFO_RESPONSE						            = 301;
public static readonly ACCOUNT_LIST_REQUEST						            = 302;
public static readonly ACCOUNT_LIST_RESPONSE					            = 303;
public static readonly ACCOUNT_RMS_INFO_REQUEST					          = 304;
public static readonly ACCOUNT_RMS_INFO_RESPONSE				          = 305;
public static readonly PRODUCT_RMS_INFO_REQUEST					          = 306;
public static readonly PRODUCT_RMS_INFO_RESPONSE				          = 307;
public static readonly SUBSCRIBE_FOR_ORDER_UPDATES_REQUEST		    = 308;
public static readonly SUBSCRIBE_FOR_ORDER_UPDATES_RESPONSE		    = 309;
public static readonly TRADE_ROUTES_REQUEST						            = 310;
public static readonly TRADE_ROUTES_RESPONSE					            = 311;
public static readonly NEW_ORDER_REQUEST						              = 312;
public static readonly NEW_ORDER_RESPONSE						              = 313;
public static readonly MODIFY_ORDER_REQUEST						            = 314;
public static readonly MODIFY_ORDER_RESPONSE					            = 315;
public static readonly CANCEL_ORDER_REQUEST						            = 316;
public static readonly CANCEL_ORDER_RESPONSE					            = 317;
public static readonly SHOW_ORDER_HISTORY_DATES_REQUEST			      = 318;
public static readonly SHOW_ORDER_HISTORY_DATES_RESPONSE		      = 319;
public static readonly SHOW_ORDERS_REQUEST						            = 320;
public static readonly SHOW_ORDERS_RESPONSE						            = 321;
public static readonly SHOW_ORDER_HISTORY_REQUEST				          = 322;
public static readonly SHOW_ORDER_HISTORY_RESPONSE				        = 323;
public static readonly SHOW_ORDER_HISTORY_SUMMARY_REQUEST		      = 324;
public static readonly SHOW_ORDER_HISTORY_SUMMARY_RESPONSE		    = 325;
public static readonly SHOW_ORDER_HISTORY_DETAIL_REQUEST		      = 326;
public static readonly SHOW_ORDER_HISTORY_DETAIL_RESPONSE		      = 327;
public static readonly OCO_ORDER_REQUEST					                = 328;
public static readonly OCO_ORDER_RESPONSE					                = 329;
public static readonly BRACKET_ORDER_REQUEST				              = 330;
public static readonly BRACKET_ORDER_RESPONSE				              = 331;
public static readonly UPDATE_TARGET_BRACKET_LEVEL_REQUEST	      = 332;
public static readonly UPDATE_TARGET_BRACKET_LEVEL_RESPONSE	      = 333;
public static readonly UPDATE_STOP_BRACKET_LEVEL_REQUEST	        = 334;
public static readonly UPDATE_STOP_BRACKET_LEVEL_RESPONSE	        = 335;
public static readonly SUBSCRIBE_TO_BRACKET_UPDATES_REQUEST	      = 336;
public static readonly SUBSCRIBE_TO_BRACKET_UPDATES_RESPONSE      = 337;
public static readonly SHOW_BRACKETS_REQUEST				              = 338;
public static readonly SHOW_BRACKETS_RESPONSE				              = 339;
public static readonly SHOW_BRACKET_STOPS_REQUEST			            = 340;
public static readonly SHOW_BRACKET_STOPS_RESPONSE			          = 341;
public static readonly LIST_EXCHANGE_PERMISSIONS_REQUEST	        = 342;
public static readonly LIST_EXCHANGE_PERMISSIONS_RESPONSE	        = 343;
public static readonly LINK_ORDERS_REQUEST					              = 344;
public static readonly LINK_ORDERS_RESPONSE					              = 345;
public static readonly CANCEL_ALL_ORDERS_REQUEST			            = 346;
public static readonly CANCEL_ALL_ORDERS_RESPONSE			            = 347;
public static readonly EASY_TO_BORROW_LIST_REQUEST			          = 348;
public static readonly EASY_TO_BORROW_LIST_RESPONSE			          = 349;

public static readonly MODIFY_ORDER_REFERENCE_DATA_REQUEST	      = 3500;
public static readonly MODIFY_ORDER_REFERENCE_DATA_RESPONSE	      = 3501;
public static readonly ORDER_SESSION_CONFIG_REQUEST			          = 3502;
public static readonly ORDER_SESSION_CONFIG_RESPONSE		          = 3503;
public static readonly EXIT_POSITION_REQUEST			                = 3504;
public static readonly EXIT_POSITION_RESPONSE		                  = 3505;

public static readonly RMS_UPDATES_REQUEST                        = 3508;
public static readonly RMS_UPDATES_RESPONSE                       = 3509;

public static readonly TRADE_ROUTE							                  = 350;
public static readonly RITHMIC_ORDER_NOTIFICATION				          = 351;
public static readonly EXCHANGE_ORDER_NOTIFICATION				        = 352;
public static readonly BRACKET_UPDATES						                = 353;
public static readonly ACCOUNT_LIST_UPDATES					              = 354;
public static readonly UPDATE_EASY_TO_BORROW_LIST			            = 355;

public static readonly RMS_ACCOUNT_UPDATES                        = 356;

//History
public static readonly TIME_BAR_UPDATE_REQUEST					          = 200;
public static readonly TIME_BAR_UPDATE_RESPONSE					          = 201;
public static readonly TIME_BAR_REPLAY_REQUEST					          = 202;
public static readonly TIME_BAR_REPLAY_RESPONSE					          = 203;
public static readonly TICK_BAR_UPDATE_REQUEST					          = 204;
public static readonly TICK_BAR_UPDATE_RESPONSE					          = 205;
public static readonly TICK_BAR_REPLAY_REQUEST					          = 206;
public static readonly TICK_BAR_REPLAY_RESPONSE					          = 207;

public static readonly TIME_BAR								                    = 250;
public static readonly TICK_BAR								                    = 251;

public static readonly PNL_POSITION_UPDATES_REQUEST				        = 400;
public static readonly PNL_POSITION_UPDATES_RESPONSE			        = 401;
public static readonly PNL_POSITION_SNAPSHOT_REQUEST			        = 402;
public static readonly PNL_POSITION_SNAPSHOT_RESPONSE			        = 403;

public static readonly INSTRUMENT_PNL_POSITION_UPDATE			        = 450;
public static readonly ACCOUNT_PNL_POSITION_UPDATE				        = 451;

//Repository
public static readonly LIST_UNACCEPTED_AGREEMENTS_REQUEST	        = 500;
public static readonly LIST_UNACCEPTED_AGREEMENTS_RESPONSE		    = 501;

public static readonly MRKT_DATA_SNAPSHOT_REQUEST                 = 100000;
public static readonly MRKT_DATA_SNAPSHOT_RESPONSE                = 100001;
public static readonly GET_USER_SETTINGS_REQUEST                  = 100002;
public static readonly GET_USER_SETTINGS_RESPONSE                 = 100003;
public static readonly SET_USER_SETTINGS_REQUEST                  = 100004;
public static readonly SET_USER_SETTINGS_RESPONSE                 = 100005;

public static readonly BINARY_CONTRACT_REF_DATA_REQUEST           = 100006;
public static readonly BINARY_CONTRACT_REF_DATA_RESPONSE          = 100007;

public static readonly WS_TMPLT_ID_PVT_RQ_LOAD_REF_DATA           = 100008;
public static readonly WS_TMPLT_ID_PVT_RP_LOAD_REF_DATA           = 100009;

};

/*   ====================================================================   */